'use client';

import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import { dataLayerPush, Events } from '@libs/analytics';
import { getENV } from '@libs/common-next';
import { BuyItAgainItem } from '@libs/common-types';

import { resolvePrice } from './resolve-price';

export function useTrackProduct({ product, onView }: { product: BuyItAgainItem; onView?: () => void }) {
    const { ref, inView } = useInView({ triggerOnce: !onView, threshold: 0.2 });

    useEffect(() => {
        if (!inView) return;

        if (onView) {
            onView();
            return;
        }

        dataLayerPush({ ecommerce: null });
        dataLayerPush({
            event: Events.VIEW_ITEM_LIST,
            ecommerce: {
                currency: getENV('NEXT_PUBLIC_LOCALE') === 'en-CA' ? 'CAD' : 'USD',
                category: null,
                sub_category1: null,
                sub_category2: null,
                item: {
                    item_name: product.name,
                    item_id: product.webStyleId,
                    price: resolvePrice(product.price),
                    item_category: product.itemCategory ?? null,
                    item_category2: product.itemCategory2 ?? null,
                    item_category3: product.itemCategory3 ?? null,
                    item_category4: product.itemCategory4 ?? null,
                    item_category5: product.itemCategory5 ?? null,
                    item_brand: product.brand ?? null,
                    item_variant: product.sku,
                    index: product.recommendationRank,
                    item_list_name: 'buy again',
                    item_list_id: 'standard plp',
                    item_search_term: null,
                },
            },
        });
    }, [inView, product, onView]);

    return { ref };
}
